/* @flow */
import React from 'react';

import cx from 'classnames';
import './styles/Box.scss';

/**
  * This is a component that creates a Box with rounded corners.
  * This is used with BoxHeader, BoxBody and BoxTitle and can also be used
  * with other layouting components like Columns and Columns2.
  */
class Box extends React.Component {
  render() {
    return (
      <div className={cx('Box', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default Box;



// WEBPACK FOOTER //
// ./src/components/Box.jsx